<!-- gridster resets its own inline height on every layout pass, so the height lives on this wrapper -->
<div class="dashboard-grid-canvas__frame" [style.height.px]="stacked() ? null : heightPx()">
  <gridster class="dashboard-grid-canvas__gridster" [options]="options()">
    @for (item of items(); track item.widget.id) {
      <gridster-item class="dashboard-grid-canvas__item" [item]="item.gridster" [attr.data-widget-id]="item.widget.id">
        <ng-container
          [ngTemplateOutlet]="itemTemplate().template"
          [ngTemplateOutletContext]="{ $implicit: item.widget }" />
      </gridster-item>
    }
  </gridster>
</div>
